import { render, staticRenderFns } from "./addNewNumbers.vue?vue&type=template&id=bbf9af12&scoped=true"
import script from "./addNewNumbers.vue?vue&type=script&lang=js"
export * from "./addNewNumbers.vue?vue&type=script&lang=js"
import style0 from "./addNewNumbers.vue?vue&type=style&index=0&id=bbf9af12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf9af12",
  null
  
)

export default component.exports